export class ExamplePostpositionTree {
  id: number;
  name: string;

  constructor(obj?: any) {
    this.id = (obj && obj.id) ?? null;
    this.name = (obj && obj.name) ?? null;
  }
}

export class ExampleCatTree {
  id: number;
  name: string;
  postpositions: Array<ExamplePostpositionTree>;

  constructor(obj?: any) {
    this.id = (obj && obj.id) ?? null;
    this.name = (obj && obj.name) ?? null;

    this.postpositions = new Array<ExamplePostpositionTree>();
    if (obj?.postpositions && Array.isArray(obj.postpositions)) {
      obj.postpositions.forEach((value: any) => {
        this.postpositions.push(new ExamplePostpositionTree(value));
      });
    }
  }
}
